"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var styles = require("./index.module.css");
var FileInfo = /** @class */ (function (_super) {
    __extends(FileInfo, _super);
    function FileInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.input = React.createRef();
        return _this;
    }
    FileInfo.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style, value = _a.value;
        if (!value) {
            return (React.createElement("div", { className: classnames_1.default(styles.fileInfo, className), style: style }, "-"));
        }
        var scale = (Math.log(value.size) / Math.log(1000)) | 0;
        var unit = value.size ? ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'][scale] : 'byte';
        return (React.createElement("div", { className: classnames_1.default(styles.fileInfo, className), style: style },
            React.createElement("span", { className: styles.fileName }, value.name),
            React.createElement("span", { className: styles.fileSize }, Math.round(value.size / Math.pow(1024, scale)) + " " + unit)));
    };
    return FileInfo;
}(React.Component));
exports.default = FileInfo;
